export const SID_LOADING = "1";
export const SID_WELCOME_1 = "2_1";
export const SID_WELCOME_2 = "2_2";
export const SID_WELCOME_3 = "2_3";
export const SID_TRANSITION = "3";
export const SID_GAME = "4";

